import {
	Vector3,
	Color,
	Vector2
} from 'three';

const colorData = {
	envirmentIndex:12,
	envirmentBrightNess: 2.0,
	envirmentRotation: 1.5707963267948966,
	diamond: [{
		// 白
		colorCorrection: new Vector3(1, 1, 1),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity: 0.5,
		n2: 2.4,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor: 1,
		rIndexDelta:0.002,
		colorRGBIntencity: 1
	},
	{
		colorCorrection: new Vector3(0.15,0.4,0.5),
		boostFactors: new Vector3(2, 2, 2),
		envMapIntensity:0.8,
		n2: 1.5,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:1,
		rIndexDelta:0.0,
		colorRGBIntencity: 2
		// 海宝蓝

	},
	{
		// 红宝石
		colorCorrection: new Vector3(1,0.0,0.0),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.4,
		n2: 1.8,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.001,
		colorRGBIntencity: 1
	},
	{
		// 黄宝石
		colorCorrection: new Vector3(2,2,0.7),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.3267,
		n2: 2.4,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.001,
		colorRGBIntencity: 0.5
	},
	{
		// 蓝宝石
		colorCorrection: new Vector3(0,0.4305,1),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.4,
		n2: 1.8,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.0,
		colorRGBIntencity: 1
	},
	{
		// 粉宝石
		colorCorrection: new Vector3(1.5,0.4,0.8),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.5,
		n2: 1.6,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.001,
		colorRGBIntencity: 1
	},
	{
		// 紫宝石
		colorCorrection: new Vector3(1.0,0.3,1.0),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.3,
		n2: 1.6,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.0,
		colorRGBIntencity: 0.5
	},
	{
		// 淡粉钻
		colorCorrection: new Vector3(1.4,0.9,0.8),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.5,
		n2: 1.7,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.0,
		colorRGBIntencity: 2
	},
	{
		// 绿宝石
		colorCorrection: new Vector3(0.2,0.7,0.2),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity:0.4,
		n2: 1.6,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor:0.9,
		rIndexDelta:0.,
		colorRGBIntencity: 0.5
	},
	{
		// 默认
		colorCorrection: new Vector3(1, 1, 1),
		boostFactors: new Vector3(1, 1, 1),
		envMapIntensity: 0.5,
		n2: 2.4,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor: 1,
		rIndexDelta:0.002,
		colorRGBIntencity: 1
	},
	],
	"RingMConfig": {
		"materials": [
            {
                "isPBRShaderMaterial":true,
                "name":"白金",
                "_MaterialType": 0,
                "mapTransform":[1,0,0,0,1,0,0,0,1],
                "alphaMapTransform":[1,0,0,0,1,0,0,0,1],
                "emissiveMapTransform":[1,0,0,0,1,0,0,0,1],
                "roughnessMapTransform":[1,0,0,0,1,0,0,0,1],
                "metalnessMapTransform":[1,0,0,0,1,0,0,0,1],
                "aoMapTransform":[1,0,0,0,1,0,0,0,1],
                "normalMapTransform":[1,0,0,0,1,0,0,0,1],
                "bumpMapTransform":[1,0,0,0,1,0,0,0,1],
                "lightMapTransform":[1,0,0,0,1,0,0,0,1],
                "translucencyMapTransform":[1,0,0,0,1,0,0,0,1],
                "diffuse":[0.6941176470588235,0.6941176470588235,0.6941176470588235],
                "useSSS":false,
                "translucency_uv":0,
                "uSubsurfaceTranslucencyThicknessFactor":1.06,
                "uSubsurfaceTranslucencyFactor":1,
                "uSubsurfaceTranslucencyColor":[0,1,0],
                "uClearCoatFactor":8,
                "uEmitMultiplicative":0,
                "uClearCoatRoughnessFactor":0,
                "uClearCoatIor":1.7999999999999998,
                "uClearCoatTint":[1,1,1],
                "uClearCoatThickness":1,
                "normalScale":[1,1],
                "bumpScale":1,
                "uEnvironmentTransform":[-0.06914844865406189,2.7755575615628914e-17,0.9976063813191736,0,0.49135590842049737,0.8702927222980656,0.03405802071890951,0,-0.8682095733801858,0.4925348490361082,-0.06017939162183161,0,0,0,0,1],
                "emissiveIntensity":-0.1,
                "uSpecularF0Factor":1,
                "useClearCoat":true,
                "uClearCoatF0":0.08,
                "uSpecularPeak":0,
                "lightMapIntensity":1,
                "uMultiplyLightMap":0,
                "emissive":[1,1,1],
                "roughness":0.1,
                "metalness":0.95,
                "envMapIntensity":1,
                "opacity":1,
                "uDrawOpaque":0,
                "uAOPBROccludeSpecular":1,
                "map_uv":0,
                "alphaMap_uv":0,
                "emissiveMap_uv":0,
                "roughnessMap_uv":0,
                "metalnessMap_uv":0,
                "aoMap_uv":0,
                "normalMap_uv":0,
                "bumpMap_uv":0,
                "lightMap_uv":0,
                "uNormalMapFlipY":0,
                "uNormalMapFactor":1,
                "aoMapIntensity":1,
                "uOpacityAdditive":0,
                "isPreCustomMetalMaterial":true,
                "MetalIndex":0,
                "map":null,
                "alphaMap":null,
                "roughnessMap":null,
                "metalnessMap":null,
                "aoMap":null,
                "lightMap":null,
                "translucencyMap":null
            }, {
                "isPBRShaderMaterial": true,
                "_MaterialType": 1,
                "name": "玫瑰金",
                "mapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "alphaMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "emissiveMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "roughnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "metalnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "aoMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "normalMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "bumpMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "lightMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "translucencyMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "diffuse": [0.6941176470588235, 0.6941176470588235, 0.6941176470588235],
                "useSSS": false,
                "translucency_uv": 0,
                "uSubsurfaceTranslucencyThicknessFactor": 1.06,
                "uSubsurfaceTranslucencyFactor": 1,
                "uSubsurfaceTranslucencyColor": [0, 1, 0],
                "uClearCoatFactor": 8,
                "uEmitMultiplicative": 0,
                "uClearCoatRoughnessFactor": 0,
                "uClearCoatIor": 1.76,
                "uClearCoatTint": [0.9921568627450981, 0.8862745098039215, 0.8392156862745098],
                "uClearCoatThickness": 1,
                "normalScale": [1, 1],
                "bumpScale": 1,
                "uEnvironmentTransform": [0.44017748371629095, -2.7755575615628914e-17, -0.8979107877897414, 0, -0.25675958771411134, 0.9582438755126975, -0.12586973090972037, 0, 0.8604175131563012, 0.28595222510483437, 0.42179737790972593, 0, 0, 0, 0, 1],
                "emissiveIntensity": -0.1,
                "uSpecularF0Factor": 1,
                "useClearCoat": true,
                "uClearCoatF0": 0.07600000000000001,
                "uSpecularPeak": 0,
                "lightMapIntensity": 0,
                "uMultiplyLightMap": 0,
                "emissive": [1, 1, 1],
                "roughness": 0.05,
                "metalness": 0.95,
                "envMapIntensity": 1,
                "opacity": 1,
                "uDrawOpaque": 0,
                "uAOPBROccludeSpecular": true,
                "map_uv": 1,
                "alphaMap_uv": 0,
                "emissiveMap_uv": 0,
                "roughnessMap_uv": 0,
                "metalnessMap_uv": 0,
                "aoMap_uv": 0,
                "normalMap_uv": 0,
                "bumpMap_uv": 0,
                "lightMap_uv": 0,
                "uNormalMapFlipY": 0,
                "uNormalMapFactor": 1,
                "aoMapIntensity": 1,
                "uOpacityAdditive": 0,
                "isPreCustomMetalMaterial": true,
                "MetalIndex": 1,
                "map": null,
                "alphaMap": null,
                "roughnessMap": null,
                "metalnessMap": null,
                "aoMap": null,
                "lightMap": null,
                "translucencyMap": null
            }, {
                "isPBRShaderMaterial": true,
                "name": "黄金",
                "_MaterialType": 2,
                "mapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "alphaMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "emissiveMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "roughnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "metalnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "aoMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "normalMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "bumpMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "lightMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "translucencyMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "diffuse": [0.6941176470588235, 0.6941176470588235, 0.6941176470588235],
                "useSSS": false,
                "translucency_uv": 0,
                "uSubsurfaceTranslucencyThicknessFactor": 1.06,
                "uSubsurfaceTranslucencyFactor": 1,
                "uSubsurfaceTranslucencyColor": [0, 1, 0],
                "uClearCoatFactor": 8,
                "uEmitMultiplicative": 0,
                "uClearCoatRoughnessFactor": 0,
                "uClearCoatIor": 1.7999999999999998,
                "uClearCoatTint": [1, 0.9215686274509803, 0.8117647058823529],
                "uClearCoatThickness": 1,
                "normalScale": [1, 1],
                "bumpScale": 1,
                "uEnvironmentTransform": [0.26267771404321194, -2.7755575615628914e-17, -0.9648836295352061, 0, -0.2480528159926157, 0.9663899781345134, -0.06752933169599848, 0, 0.9324538696488778, 0.2570805518921543, 0.2538491103306436, 0, 0, 0, 0, 1],
                "emissiveIntensity": -0.1,
                "uSpecularF0Factor": 1,
                "useClearCoat": true,
                "uClearCoatF0": 0.07999999999999999,
                "uSpecularPeak": 0,
                "lightMapIntensity": 1,
                "uMultiplyLightMap": 0,
                "emissive": [1, 1, 1],
                "roughness": 0.05,
                "metalness": 0.95,
                "envMapIntensity": 1,
                "opacity": 1,
                "uDrawOpaque": 0,
                "uAOPBROccludeSpecular": 1,
                "map_uv": 0,
                "alphaMap_uv": 0,
                "emissiveMap_uv": 0,
                "roughnessMap_uv": 0,
                "metalnessMap_uv": 0,
                "aoMap_uv": 0,
                "normalMap_uv": 0,
                "bumpMap_uv": 0,
                "lightMap_uv": 0,
                "uNormalMapFlipY": 0,
                "uNormalMapFactor": 1,
                "aoMapIntensity": 1,
                "uOpacityAdditive": 0,
                "isPreCustomMetalMaterial": true,
                "MetalIndex": 2,
                "map": null,
                "alphaMap": null,
                "roughnessMap": null,
                "metalnessMap": null,
                "aoMap": null,
                "lightMap": null,
                "translucencyMap": null
            }, {
                "isPBRShaderMaterial": true,
                "_MaterialType": 0,
                "name": "白金",
                "mapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "alphaMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "emissiveMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "roughnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "metalnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "aoMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "normalMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "bumpMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "lightMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "translucencyMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "diffuse": [0.6941176470588235, 0.6941176470588235, 0.6941176470588235],
                "useSSS": false,
                "translucency_uv": 0,
                "uSubsurfaceTranslucencyThicknessFactor": 1.06,
                "uSubsurfaceTranslucencyFactor": 1,
                "uSubsurfaceTranslucencyColor": [0, 1, 0],
                "uClearCoatFactor": 8,
                "uEmitMultiplicative": 0,
                "uClearCoatRoughnessFactor": 0,
                "uClearCoatIor": 1.7999999999999998,
                "uClearCoatTint": [1, 1, 1],
                "uClearCoatThickness": 1,
                "normalScale": [1, 1],
                "bumpScale": 1,
                "uEnvironmentTransform": [0.44017748371629095, -2.7755575615628914e-17, -0.8979107877897414, 0, -0.25675958771411134, 0.9582438755126975, -0.12586973090972037, 0, 0.8604175131563012, 0.28595222510483437, 0.42179737790972593, 0, 0, 0, 0, 1],
                "emissiveIntensity": -0.2,
                "uSpecularF0Factor": 1,
                "useClearCoat": true,
                "uClearCoatF0": 0.08,
                "uSpecularPeak": 0,
                "lightMapIntensity": 1,
                "uMultiplyLightMap": 0,
                "emissive": [1, 1, 1],
                "roughness": 0.05,
                "metalness": 0.95,
                "envMapIntensity": 1,
                "opacity": 1,
                "uDrawOpaque": 0,
                "uAOPBROccludeSpecular": 1,
                "map_uv": 0,
                "alphaMap_uv": 0,
                "emissiveMap_uv": 0,
                "roughnessMap_uv": 0,
                "metalnessMap_uv": 0,
                "aoMap_uv": 0,
                "normalMap_uv": 0,
                "bumpMap_uv": 0,
                "lightMap_uv": 0,
                "uNormalMapFlipY": 0,
                "uNormalMapFactor": 1,
                "aoMapIntensity": 1,
                "uOpacityAdditive": 0,
                "isPreCustomMetalMaterial": true,
                "MetalIndex": 0,
                "map": null,
                "alphaMap": null,
                "roughnessMap": null,
                "metalnessMap": null,
                "aoMap": null,
                "lightMap": null,
                "translucencyMap": null
            },{
                "isPBRShaderMaterial": true,
                "_MaterialType": 4,
                "name": "足金",
                "mapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "alphaMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "emissiveMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "roughnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "metalnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "aoMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "normalMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "bumpMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "lightMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "translucencyMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "diffuse": [0.6941176470588235, 0.6941176470588235, 0.6941176470588235],
                "useSSS": false,
                "translucency_uv": 0,
                "uSubsurfaceTranslucencyThicknessFactor": 1.06,
                "uSubsurfaceTranslucencyFactor": 1,
                "uSubsurfaceTranslucencyColor": [0, 1, 0],
                "uClearCoatFactor": 8,
                "uEmitMultiplicative": 0,
                "uClearCoatRoughnessFactor": 0,
                "uClearCoatIor": 1.7999999999999998,
                "uClearCoatTint": [1, 0.8784313725490196, 0.6470588235294118],
                "uClearCoatThickness": 0.8,
                "normalScale": [1, 1],
                "bumpScale": 1,
                "uEnvironmentTransform": [0.26267771404321194, -2.7755575615628914e-17, -0.9648836295352061, 0, -0.2480528159926157, 0.9663899781345134, -0.06752933169599848, 0, 0.9324538696488778, 0.2570805518921543, 0.2538491103306436, 0, 0, 0, 0, 1],
                "emissiveIntensity": -0.1,
                "uSpecularF0Factor": 1,
                "useClearCoat": true,
                "uClearCoatF0": 0.07999999999999999,
                "uSpecularPeak": 0,
                "lightMapIntensity": 1,
                "uMultiplyLightMap": 0,
                "emissive": [1, 1, 1],
                "roughness": 0.05,
                "metalness": 0.95,
                "envMapIntensity": 1,
                "opacity": 1,
                "uDrawOpaque": 0,
                "uAOPBROccludeSpecular": true,
                "map_uv": 0,
                "alphaMap_uv": 0,
                "emissiveMap_uv": 0,
                "roughnessMap_uv": 0,
                "metalnessMap_uv": 0,
                "aoMap_uv": 0,
                "normalMap_uv": 0,
                "bumpMap_uv": 0,
                "lightMap_uv": 0,
                "uNormalMapFlipY": 0,
                "uNormalMapFactor": 1,
                "aoMapIntensity": 1,
                "uOpacityAdditive": 0,
                "isPreCustomMetalMaterial": true,
                "MetalIndex": 4,
                "map": null,
                "alphaMap": null,
                "roughnessMap": null,
                "metalnessMap": null,
                "aoMap": null,
                "lightMap": null,
                "translucencyMap": null
            }, {
                "isPBRShaderMaterial": true,
                "name": "18k黄2",
                "_MaterialType": 5,
                "mapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "alphaMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "emissiveMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "roughnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "metalnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "aoMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "normalMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "bumpMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "lightMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "translucencyMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "diffuse": [0.6941176470588235, 0.6941176470588235, 0.6941176470588235],
                "useSSS": false,
                "translucency_uv": 0,
                "uSubsurfaceTranslucencyThicknessFactor": 1.06,
                "uSubsurfaceTranslucencyFactor": 1,
                "uSubsurfaceTranslucencyColor": [0, 1, 0],
                "uClearCoatFactor": 9,
                "uEmitMultiplicative": 0,
                "uClearCoatRoughnessFactor": 0.1,
                "uClearCoatIor": 1.7999999999999998,
                "uClearCoatTint": [0.9647058823529412, 0.9019607843137255, 0.8235294117647058],
                "uClearCoatThickness": 1.8,
                "normalScale": [1, 1],
                "bumpScale": 1,
                "uEnvironmentTransform": [0.26267771404321194, -2.7755575615628914e-17, -0.9648836295352061, 0, -0.2480528159926157, 0.9663899781345134, -0.06752933169599848, 0, 0.9324538696488778, 0.2570805518921543, 0.2538491103306436, 0, 0, 0, 0, 1],
                "emissiveIntensity": -0.1,
                "uSpecularF0Factor": 1,
                "useClearCoat": true,
                "uClearCoatF0": 0.07999999999999999,
                "uSpecularPeak": 0,
                "lightMapIntensity": 1,
                "uMultiplyLightMap": 0,
                "emissive": [1, 1, 1],
                "roughness": 0.05,
                "metalness": 1,
                "envMapIntensity": 1,
                "opacity": 1,
                "uDrawOpaque": 0,
                "uAOPBROccludeSpecular": 1,
                "map_uv": 0,
                "alphaMap_uv": 0,
                "emissiveMap_uv": 0,
                "roughnessMap_uv": 0,
                "metalnessMap_uv": 0,
                "aoMap_uv": 0,
                "normalMap_uv": 0,
                "bumpMap_uv": 0,
                "lightMap_uv": 0,
                "uNormalMapFlipY": 0,
                "uNormalMapFactor": 1,
                "aoMapIntensity": 1,
                "uOpacityAdditive": 0,
                "isPreCustomMetalMaterial": true,
                "MetalIndex": 5,
                "map": null,
                "alphaMap": null,
                "roughnessMap": null,
                "metalnessMap": null,
                "aoMap": null,
                "lightMap": null,
                "translucencyMap": null
            }, {
                "isPBRShaderMaterial": true,
                "name": "18k黄3",
                "_MaterialType": 6,
                "mapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "alphaMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "emissiveMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "roughnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "metalnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "aoMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "normalMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "bumpMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "lightMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "translucencyMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "diffuse": [0.6941176470588235, 0.6941176470588235, 0.6941176470588235],
                "useSSS": false,
                "translucency_uv": 0,
                "uSubsurfaceTranslucencyThicknessFactor": 1.06,
                "uSubsurfaceTranslucencyFactor": 1,
                "uSubsurfaceTranslucencyColor": [0, 1, 0],
                "uClearCoatFactor": 9,
                "uEmitMultiplicative": 0,
                "uClearCoatRoughnessFactor": 0,
                "uClearCoatIor": 1.7999999999999998,
                "uClearCoatTint": [0.9450980392156862, 0.8784313725490196, 0.7725490196078432],
                "uClearCoatThickness": 1.8,
                "normalScale": [1, 1],
                "bumpScale": 1,
                "uEnvironmentTransform": [0.26267771404321194, -2.7755575615628914e-17, -0.9648836295352061, 0, -0.2480528159926157, 0.9663899781345134, -0.06752933169599848, 0, 0.9324538696488778, 0.2570805518921543, 0.2538491103306436, 0, 0, 0, 0, 1],
                "emissiveIntensity": -0.1,
                "uSpecularF0Factor": 1,
                "useClearCoat": true,
                "uClearCoatF0": 0.07999999999999999,
                "uSpecularPeak": 0,
                "lightMapIntensity": 1,
                "uMultiplyLightMap": 1,
                "emissive": [1, 1, 1],
                "roughness": 0.05,
                "metalness": 1,
                "envMapIntensity": 1,
                "opacity": 1,
                "uDrawOpaque": 0,
                "uAOPBROccludeSpecular": 1,
                "map_uv": 1,
                "alphaMap_uv": 0,
                "emissiveMap_uv": 1,
                "roughnessMap_uv": 0,
                "metalnessMap_uv": 0,
                "aoMap_uv": 0,
                "normalMap_uv": 0,
                "bumpMap_uv": 0,
                "lightMap_uv": 0,
                "uNormalMapFlipY": 0,
                "uNormalMapFactor": 1,
                "aoMapIntensity": 1,
                "uOpacityAdditive": 0,
                "isPreCustomMetalMaterial": true,
                "MetalIndex": 6,
                "map": null,
                "alphaMap": null,
                "roughnessMap": null,
                "metalnessMap": null,
                "aoMap": null,
                "lightMap": null,
                "translucencyMap": null
            }, 
            {
                "isPBRShaderMaterial": true,
                "name": "18k红2",
                "_MaterialType": 7,
                "mapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "alphaMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "emissiveMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "roughnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "metalnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "aoMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "normalMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "bumpMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "lightMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "translucencyMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "diffuse": [0.6941176470588235, 0.6941176470588235, 0.6941176470588235],
                "useSSS": false,
                "translucency_uv": 0,
                "uSubsurfaceTranslucencyThicknessFactor": 1.06,
                "uSubsurfaceTranslucencyFactor": 1,
                "uSubsurfaceTranslucencyColor": [0, 1, 0],
                "uClearCoatFactor": 10,
                "uEmitMultiplicative": 0,
                "uClearCoatRoughnessFactor": 0.1,
                "uClearCoatIor": 1.76,
                "uClearCoatTint": [0.9921568627450981, 0.8862745098039215, 0.8392156862745098],
                "uClearCoatThickness": 1,
                "normalScale": [1, 1],
                "bumpScale": 1,
                "uEnvironmentTransform": [0.44017748371629095, -2.7755575615628914e-17, -0.8979107877897414, 0, -0.25675958771411134, 0.9582438755126975, -0.12586973090972037, 0, 0.8604175131563012, 0.28595222510483437, 0.42179737790972593, 0, 0, 0, 0, 1],
                "emissiveIntensity": -0.15,
                "uSpecularF0Factor": 1,
                "useClearCoat": true,
                "uClearCoatF0": 0.07600000000000001,
                "uSpecularPeak": 0,
                "lightMapIntensity": 0,
                "uMultiplyLightMap": 0,
                "emissive": [1, 1, 1],
                "roughness": 0.05,
                "metalness": 1,
                "envMapIntensity": 1,
                "opacity": 1,
                "uDrawOpaque": 0,
                "uAOPBROccludeSpecular": true,
                "map_uv": 1,
                "alphaMap_uv": 0,
                "emissiveMap_uv": 0,
                "roughnessMap_uv": 0,
                "metalnessMap_uv": 0,
                "aoMap_uv": 0,
                "normalMap_uv": 0,
                "bumpMap_uv": 0,
                "lightMap_uv": 0,
                "uNormalMapFlipY": 0,
                "uNormalMapFactor": 1,
                "aoMapIntensity": 1,
                "uOpacityAdditive": 0,
                "isPreCustomMetalMaterial": true,
                "MetalIndex": 7,
                "map": null,
                "alphaMap": null,
                "roughnessMap": null,
                "metalnessMap": null,
                "aoMap": null,
                "lightMap": null,
                "translucencyMap": null
            }, 
            {
                "isPBRShaderMaterial": true,
                "name": "18k红3",
                "_MaterialType": 8,
                "mapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "alphaMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "emissiveMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "roughnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "metalnessMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "aoMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "normalMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "bumpMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "lightMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "translucencyMapTransform": [1, 0, 0, 0, 1, 0, 0, 0, 1],
                "diffuse": [0.6941176470588235, 0.6941176470588235, 0.6941176470588235],
                "useSSS": false,
                "translucency_uv": 0,
                "uSubsurfaceTranslucencyThicknessFactor": 1.06,
                "uSubsurfaceTranslucencyFactor": 1,
                "uSubsurfaceTranslucencyColor": [0, 1, 0],
                "uClearCoatFactor": 10,
                "uEmitMultiplicative": 0,
                "uClearCoatRoughnessFactor": 0.1,
                "uClearCoatIor": 1.74,
                "uClearCoatTint": [0.9921568627450981, 0.8862745098039215, 0.8392156862745098],
                "uClearCoatThickness": 1,
                "normalScale": [1, 1],
                "bumpScale": 1,
                "uEnvironmentTransform": [0.2141253530535665, 0, 0.9768061901829274, 0, 0.1796801126128813, 0.9829362506302316, -0.039387616434671355, 0, -0.9601382141708076, 0.1839465335280404, 0.21047157169534725, 0, 0, 0, 0, 1],
                "emissiveIntensity": -0.15,
                "uSpecularF0Factor": 1,
                "useClearCoat": true,
                "uClearCoatF0": 0.07400000000000001,
                "uSpecularPeak": 0,
                "lightMapIntensity": 0,
                "uMultiplyLightMap": 0,
                "emissive": [1, 1, 1],
                "roughness": 0.05,
                "metalness": 1,
                "envMapIntensity": 1,
                "opacity": 1,
                "uDrawOpaque": 0,
                "uAOPBROccludeSpecular": true,
                "map_uv": 1,
                "alphaMap_uv": 0,
                "emissiveMap_uv": 0,
                "roughnessMap_uv": 0,
                "metalnessMap_uv": 0,
                "aoMap_uv": 0,
                "normalMap_uv": 0,
                "bumpMap_uv": 0,
                "lightMap_uv": 0,
                "uNormalMapFlipY": 0,
                "uNormalMapFactor": 1,
                "aoMapIntensity": 1,
                "uOpacityAdditive": 0,
                "map": null,
                "alphaMap": null,
                "roughnessMap": null,
                "metalnessMap": null,
                "aoMap": null,
                "lightMap": null,
                "translucencyMap": null
            }
        ]
    },
	smashDiamond: {
		// 碎钻白
		colorCorrection: new Vector3(1, 1, 1),
		boostFactors: new Vector3(6, 6, 6),
		envMapIntensity: 1.,
		n2: 2.4,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor: 0.8,
		rIndexDelta: 0.001,
		colorRGBIntencity: 0.2
	},
	// 组合款暂用
	tempSmashDiamond: {
		// 碎钻白
		colorCorrection: new Vector3(1, 1, 1),
		boostFactors: new Vector3(4, 4, 4),
		envMapIntensity: 1.,
		n2: 2.4,
		distanceOffset: 0,
		normalOffset: 0.,
		squashFactor: 0.8,
		rIndexDelta: 0.001,
		colorRGBIntencity: 0.2
	}
};

export {
	colorData
};